// extracted by mini-css-extract-plugin
export default {"root":"EditListingHRStrategicSkillsPanel_root__KPZll","form":"EditListingHRStrategicSkillsPanel_form__b6i1+","title":"EditListingHRStrategicSkillsPanel_title__nUSVA"};